import { render, staticRenderFns } from "./IcoInstructor.vue?vue&type=template&id=f4a4fbb6"
import script from "./IcoInstructor.vue?vue&type=script&lang=js"
export * from "./IcoInstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports